import { FormSection } from "Components/Shared/FormSection";
import { DateFormInput } from "Components/Shared/Inputs/Form/DateFormInput";
import { CountryDropdown } from "Components/Shared/Inputs/Form/Dropdowns/CountryDropdown";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { AddressFields } from "Components/Users/UserDetailPageContent/Components/AddressFields";
import type {
  BeneficialOwnerFormDataInput,
  BeneficialOwnerFormData,
} from "Components/Users/schemas";
import type { AddressDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { Control } from "react-hook-form";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties.Form.Fields
    .BeneficialOwnerFields;

type BeneficialOwnerPartyFormFieldsProps = {
  control: Control<
    BeneficialOwnerFormDataInput,
    unknown,
    BeneficialOwnerFormData
  >;
  addresses: Array<AddressDto>;
  partyPublicID?: string;
};

export const BeneficialOwnerPartyFormFields = ({
  control,
  addresses,
  partyPublicID,
}: BeneficialOwnerPartyFormFieldsProps) => {
  const { t } = useResource();

  return (
    <>
      <FormSection legend={t(COMPONENT_RESOURCES.Legend.PersonalData)}>
        <FormInput
          control={control}
          name="firstName"
          label={t(COMPONENT_RESOURCES.FirstName)}
        />
        <FormInput
          control={control}
          name="lastName"
          label={t(COMPONENT_RESOURCES.LastName)}
        />
        <DateFormInput
          control={control}
          name="birthDate"
          label={t(COMPONENT_RESOURCES.BirthDate)}
        />
        <CountryDropdown
          control={control}
          name="nationality"
          label={t(COMPONENT_RESOURCES.Nationality)}
        />
      </FormSection>
      <AddressFields
        control={control}
        addresses={addresses}
        partyPublicID={partyPublicID}
      />
    </>
  );
};
